import { DataBean } from "../../../DataBean";



export class ForProduct extends DataBean {


    public async getProductCostForProduct(productID:any,idStore:any,date:any,validateQuantities:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "inventory.ProductCost_getProductCostForProduct_Number_Number_java.util.Date_Boolean", [productID,idStore,date,validateQuantities]);
    }


}